import { render, staticRenderFns } from "./ChatEditable.vue?vue&type=template&id=092fc872&"
import script from "./ChatEditable.vue?vue&type=script&lang=js&"
export * from "./ChatEditable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports